import { Fragment, ReactElement, ReactNode } from 'react'

import { isFunction } from 'lodash'

type ReactRenderPropsChildren<T = any> =
  | ReactNode
  | ((props: T) => ReactElement)

type IPasswordStrengthProps = {
  value?: ReactNode
  // 返回 0~100 之间的数字，表示密码强度
  getStrength?: (value: string) => number
  children?: ReactRenderPropsChildren<number>
}

const defaultGetStrength = (value?: string) => {
  let score = 0
  if (!value) {
    return score
  }
  // 符合长度要求
  if (value.length >= 6) {
    score += 20
  }
  // 包含数字
  if (/\d/.test(value)) {
    score += 20
  }
  // 包含小写字母
  if (/[a-z]/.test(value)) {
    score += 20
  }
  // 包含大写字母
  if (/[A-Z]/.test(value)) {
    score += 20
  }
  // 包含特殊字符
  if (/[^A-Za-z0-9]/.test(value)) {
    score += 20
  }
  return score
}

export const PasswordStrength = ({
  value,
  getStrength = defaultGetStrength,
  children
}: IPasswordStrengthProps) => {
  if (isFunction(children)) {
    return children(value === 'undefined' ? 0 : getStrength(String(value)))
  } else {
    return <Fragment>{children}</Fragment>
  }
}
